"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SessState_1 = require("./session/SessState");

var PantState_1 = require("./PantState");

var NotiState_1 = require("./NotiState");

var OpenState_1 = require("./OpenState");

var MenuState_1 = require("./MenuState");

var DialState_1 = require("./DialState");

var LoadState_1 = require("./LoadState");

var VersState_1 = require("./VersState");

var url_1 = require("../util/url"); // console.log(process.env.REACT_APP_ENTORN);
// console.log(process.env.NODE_ENV);


var entorn = process.env.REACT_APP_ENTORN || (process.env.NODE_ENV === 'development' ? 'Desenvolupament' : process.env.NODE_ENV === 'test' ? 'Proves' : url_1.getEntornFormUrl());
var defaultConfig = {
  bd: 'AJT',
  titol: '[titol]',
  urlBase: '/',
  progressLoadingTimeOut: 1000,
  entorn: entorn
};

var AjtAppState =
/** @class */
function () {
  function AjtAppState(config) {
    this.config = Object.assign(defaultConfig, config);
    this.loadState = new LoadState_1.default(this);
    this.sessState = new SessState_1.default(this);
    this.notiState = new NotiState_1.default();
    this.dialState = new DialState_1.default();
    this.openState = new OpenState_1.default(this);
    this.menuState = new MenuState_1.default();
    this.pantState = new PantState_1.default(this);
    this.versState = new VersState_1.default(this);
    this.sessState.init();
  }

  return AjtAppState;
}();

exports.default = AjtAppState;